var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardAdvancedsearchAllrecordsIcon = function SvgNewcsDashboardAdvancedsearchAllrecordsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_advancedsearch_allrecords_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59 91h16v16H59z",
    "data-name": "\\u77E9\\u5F62 497"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_advancedsearch_allrecords_icon_svg__a)",
    transform: "translate(-59 -91)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M62 107a2 2 0 0 1-2-2V93a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Zm-.5-14v12a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V93a.5.5 0 0 0-.5-.5H62a.5.5 0 0 0-.5.5m2.25 10a.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 .751.75.75.75 0 0 1-.751.75Zm0-3.25A.75.75 0 0 1 63 99a.75.75 0 0 1 .75-.75h6.5A.75.75 0 0 1 71 99a.75.75 0 0 1-.751.75Zm0-3.25a.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.751h1.5a.75.75 0 0 1 .75.751.75.75 0 0 1-.75.75Z",
    "data-name": "\\u8054\\u5408 64"
  }))));
};
export default SvgNewcsDashboardAdvancedsearchAllrecordsIcon;